import { VIA_TEST_URL, VIA_STRENGTHS, VIA_TRANSLATIONS_PT } from "../profileConstants";

// VIA-ME character strengths picker (max 5), grouped by virtue.
export const ViaPicker = ({ values, onToggle }) => (
  <div>
    <div className="flex items-baseline justify-between mb-2">
      <label className="block text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">
        5 valores mais fortes (VIA-ME) <span className="ml-2 text-[hsl(var(--muted-foreground))] normal-case tracking-normal">— {values.length}/5 selecionados</span>
      </label>
      <a
        href={VIA_TEST_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--primary))] hover:underline"
        data-testid="via-test-link"
      >
        Fazer o teste ↗
      </a>
    </div>
    <p className="text-[11px] text-[hsl(var(--muted-foreground))] mb-3 leading-relaxed">
      Não conhece os seus? <a href={VIA_TEST_URL} target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--primary))] underline">viacharacter.org</a> · grátis · ~15 min, requer registo (login Google ou email).
    </p>
    <div className="space-y-3 bg-white border border-[hsl(var(--border))] p-4">
      {Object.entries(VIA_STRENGTHS).map(([virtue, items]) => (
        <div key={virtue}>
          <div className="text-[10px] uppercase tracking-[0.16em] text-[hsl(var(--accent))] mb-1.5">{virtue}</div>
          <div className="flex flex-wrap gap-1.5">
            {items.map((val) => {
              const checked = values.includes(val);
              return (
                <button key={val} type="button" onClick={() => onToggle(val)}
                  className={`px-2.5 py-1 text-[11px] border transition-colors ${
                    checked
                      ? "bg-[hsl(var(--accent))] text-[#1A201F] border-[hsl(var(--accent))]"
                      : "bg-white border-[hsl(var(--border))] text-[hsl(var(--foreground))] hover:border-[hsl(var(--accent))]"
                  }`}
                  data-testid={`via-${val.replace(/[^a-zA-Z]/g, "")}`}>
                  {VIA_TRANSLATIONS_PT[val] || val}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  </div>
);
